import { render, staticRenderFns } from "./LogoHead.vue?vue&type=template&id=0d07dfb7&"
import script from "./LogoHead.vue?vue&type=script&lang=js&"
export * from "./LogoHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports